import classNames from 'classnames';
import { memo, useCallback, useRef } from 'react';
import { Button } from '@components/tailwind/index';
import FreeGiftModal from '@components/tailwind/FreeGiftModal';

const FreeGiftMeter = ({
  promoCodeId,
  eligible,
  amountRemainingFormatted,
  meterProgressFormatted,
  description,
  className = '',
}) => {
  const modalRef = useRef(null);

  const showModal = useCallback(() => {
    modalRef.current.openModal();
  }, []);

  return (
    <>
      <div className={classNames('tw:border-b tw:border-gray-300 tw:bg-white tw:px-5 tw:py-5', className)}>
        {!eligible && (
          <>
            <h5 className='tw:block tw:text-center tw:text-base tw:font-bold tw:text-free-shipping-meter-text'>
              Add {amountRemainingFormatted} to get your FREE {description}!
            </h5>
            <div className='tw:mt-[10px] tw:block tw:h-[10px] tw:rounded-md tw:bg-free-shipping-meter-empty'>
              <span
                className='tw:block tw:h-full tw:rounded-md tw:bg-free-shipping-meter-filled'
                style={{ width: meterProgressFormatted ?? 0 }}></span>
            </div>
          </>
        )}
        {eligible && (
          <>
            <h5 className='tw:block tw:text-center tw:text-base tw:font-bold tw:text-free-shipping-meter-text'>
              Claim your FREE {description}!
              <div className={'tw:mt-2'}>
                <Button variant='primary' size='sm' onClick={showModal}>
                  Claim your free gift
                </Button>
              </div>
            </h5>
          </>
        )}
      </div>
      <FreeGiftModal ref={modalRef} promoCodeId={promoCodeId} title={`Claim your FREE ${description}!`} />
    </>
  );
};

export default memo(FreeGiftMeter);
